import List from './views/List.vue'
import Create from './views/Create.vue'

export const ApiKeyManagementRoutes = [
  {
    path: '/api-keys-management',
    name: 'ListApiKeys',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'apikeys:list'
    }
  },
  {
    path: '/api-key-management',
    name: 'CreateApiKey',
    component: Create,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'apikeys:create'
    }
  }
]
